// extracted by mini-css-extract-plugin
export default {"collapse":"TripFiltersDrawer_collapse__pX908","sectionLabel":"TripFiltersDrawer_sectionLabel__bCb-k","footer":"TripFiltersDrawer_footer__b1tGn"};